import { Component, ViewChild, TemplateRef, ElementRef, Renderer2, OnChanges, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';
import { forkJoin, switchMap } from 'rxjs';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';

@Component({
  selector: 'app-capa',
  templateUrl: './capa.component.html',
  styleUrls: ['./capa.component.scss']
})
export class CapaComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  isProcessing = false;
  capa: any = {};

  snackbarRef: any;
  attachAllDocuments: boolean = false;
  isAllReasonSelected = false;
  isAllBusinessAreaSelected = false;
  allRootCauseCategorySelected = false;
  getQmsBusinessAreaDetail: any;
  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  ECPerformer: boolean;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isStageUsersSkipped: boolean = false;
  taskStage: any = [];
  taskStageUsers: any = [];
  objForDocuments: any;
  dynamicLabel: any = null;
  showChangeTypeIfNa: boolean = false;
  visibleReasonForChangeIfOthers: boolean = false;
  skipValidation: boolean = false;
  isAdditionalTabUser: boolean = false;

  departmentValue: any = [];
  ownerValue: any = [];
  requestedAtValue: any = [];
  coreBusinessAreaNameValue: any = [];
  selectCoreBusinessAreaNameValueExp: any = [];
  qaUserValue: any = [];
  reasonForCapaValue: any = [];
  selectedRootCauseCategory: any = [];

  editorValue: any;
  dropDownForDepartment: any = [];
  dropDownForDesignation: any = [];
  dropDownForCapaType: any = [];
  dropDownForRequestedAt: any = [];
  dropDownForCoreBusinessArea: any = [];
  ownerList: any = [];
  qaList: any = [];
  reasonForChangeList: any = [];
  rootCauseList: any = [];
  departmentHeadList: any = [];
  ecPerformerList: any = [];

  departmentCodeDropdown: any = [];
  designationCodeDropdown: any = [];
  capaTypeDropdown: any = [];
  requestedAtDropdown: any = [];
  coreBusinessAreaNameDropdown: any = [];
  ownerDropdown: any = [];
  qaDropdown: any = [];
  reasonForCapaDropdown: any = [];
  departmentHeadDropdown: any = [];
  rootCauseDropdown: any = [];

  departmentSearchText: string = '';
  designationSearchText: string = '';
  capaTypeSearchText: string = '';
  requestedAtSearchText: string = '';
  coreBusinessSearchText: string = '';
  ownerSearchText: string = '';
  qaSearchText: string = '';
  reasonForCapaSearchText: string = '';
  departmentHeadSearchText: string = '';
  rootCauseCategorySearchText: string = '';
  pdfDetailSearchText: string = '';

  isRequestedAtOdd: any = null;
  isCapaTypeOdd: any = null;
  isDhOdd: any = null;
  isOwnerOdd: any = null;
  isQAOdd: any = null;
  isDepartmentOdd: any = null;

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly message: messageService,
    readonly qualityService: qmsService,
    readonly taskActionsHistoryComponent: TaskActionsHistoryComponent,
    public dependencyNavigationService: DependencyNavigationService,

    private readonly elem: ElementRef,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.selectedTabIndex = 0;
    this.isAdditionalTabUser = this.qualityService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.getTaskStages();
    this.clearDropdowns();
  }

  ngOnChanges() {
    this.qualityService.refereshBreadCrumb = true;
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.initiate();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qualityService.moduleName == 'CAPA') {
        this.initiate();
      }
    });
  }

  private initiate() {
    this.isProcessing = true; this.ngOnChangesReportFooter(); this.getDynamicLabel(); this.main();
  }


  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  private clearDropdowns(): void {
    Object.keys(this.qualityService.capaPageAllDropdownValues).forEach(key => {
      if (key === 'coreBusinessAreaNameValue' || key === 'reasonForCapaValue' || key === 'selectedRootCauseCategory') {
        this.qualityService.capaPageAllDropdownValues[key] = [];
      } else {
        this.qualityService.capaPageAllDropdownValues[key] = null;
      }
    })
  }

  private getTaskStages(): void {
    this.appService.getTaskStages(this.qualityService.activityId, 0).subscribe((stage: any) => {
      this.taskStage = stage;
      this.isStageUsersSkipped = !stage.length;
    })
  }

  private getDynamicLabel(): void {

    const data = {
      tableName: 'QMS_CAPA_GRID_VW',
      moduleName: 'CAPA',
      gridName: 'CAPA',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        const label: [] = labelResponse;
        this.dynamicLabel = label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qualityService.activityDynamicLabel = acc;
          return acc;
        }, {});
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private async main() {

    this.qualityService.activity = {};
    this.qualityService.activityDynamicButtonList = [];
    this.objForDocuments = { id: this.qualityService.activityId, pagename: "Activity" };

    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');

    this.dropDownForDepartment.length && this.selectBoxForDepartment();
    this.dropDownForDesignation.length && this.selectBoxForDesignation();

    const groupId = this.qualityService.selectedActivityGroupId;
    const groupDetailId = this.qualityService.selectedGroupDetailData.groupDetailId;
    const moduleName = this.qualityService.moduleName;

    const getRequestedAt$ = this.appService.getAllQmsBusinessAreas();
    const getOwner$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Owner');
    const getQa$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'QA');
    const getDepartmentHead$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Department Head');
    const getEcPerformer$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer');
    const getReasonForChange$ = this.appService.getCodeListsByGroup("REASON_FOR_CAPA");
    const getCapaRootCause$ = this.appService.getCodeListsByGroup("CAPA_ROOTCAUSE_CATEGORY");
    const getParallelWorkflowList$ = this.appService.getWorkflowByRefNo(this.qualityService.activityId);
    const getTypeSettings$ = this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId);
    const getreportTemplateList$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, groupId);
    const getReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", groupId);

    forkJoin([
      getRequestedAt$, getOwner$, getQa$, getDepartmentHead$, getEcPerformer$, getReasonForChange$, getCapaRootCause$, getParallelWorkflowList$, getTypeSettings$, getreportTemplateList$, getReportImage$, getReportLogo$
    ]).pipe(
      switchMap((
        [requestedAt, owner, qa, departmentHead, ecPerformer, reasonForChange, rootCause, parallelWorkflow, typeSettings, reportTemplate, reportImage, reportLogo]) => {

        this.getQmsBusinessAreaDetail = requestedAt;
        this.dropDownForRequestedAt = this.getQmsBusinessAreaDetail.filter((item: any) => item.module === this.qualityService.moduleName);

        this.ownerList = owner;
        /*  selectBoxForOwner function has been called after activity get call to load group owners */

        this.qaList = qa;
        this.qaList.length && this.selectBoxForQa();

        this.ecPerformerList = ecPerformer;

        this.reasonForChangeList = reasonForChange;
        this.reasonForChangeList.length && this.selectBoxForReasonForChange();

        this.rootCauseList = rootCause;
        this.rootCauseList.length && this.selectBoxForRootCause();

        this.departmentHeadList = departmentHead;
        this.departmentHeadList.length && this.selectBoxForDepartmentHead();

        this.dropDownForCapaType = typeSettings;
        this.dropDownForCapaType.length && this.selectBoxForCapaType();

        this.parallelWorkflowList = parallelWorkflow;

        this.dropDownDataForReportTemplate = reportTemplate;
        this.selectBoxForReportTemplate();

        this.dropDownDataForReportLogo = reportLogo;

        this.organizationReportImageDetails = reportImage;
        this.selectBoxForReportLogo();

        return this.appService.getCapaVwDetailsByCapaNo(this.qualityService.activityId);
      })
    ).subscribe((crDetails: any) => {

      this.capa = crDetails;
      this.qualityService.activity = crDetails;

      this.capa.createdOn = this.capa.createdOn ? new Date(this.capa.createdOn) : null;
      this.capa.expcetedClosureOn = this.capa.expcetedClosureOn ? new Date(this.capa.expcetedClosureOn) : null;
      this.capa.expectedToBeStartedOn = this.capa.expectedToBeStartedOn ? new Date(this.capa.expectedToBeStartedOn) : null;
      this.capa.effectiveOn = this.capa.effectiveOn ? new Date(this.capa.effectiveOn) : null;
      this.capa.startedOn = this.capa.startedOn ? new Date(this.capa.startedOn) : null;
      this.capa.completedOn = this.capa.completedOn ? new Date(this.capa.completedOn) : null;
      this.capa.lastActionOn = this.capa.lastActionOn ? new Date(this.capa.lastActionOn) : null;
      this.capa.ownerAcceptanceRequestedOn = this.capa.ownerAcceptanceRequestedOn ? this.capa.ownerAcceptanceRequestedOn.split('T')[0] : null;
      this.capa.ownerApprovedOn = this.capa.ownerApprovedOn ? this.capa.ownerApprovedOn.split('T')[0] : null;

      this.message.showActionSection = this.capa.actionItemsReqd = this.capa.actionItemsReqd == "Y";
      this.message.showPreActionsTab = this.capa.preActionItemsReqd = this.capa.preActionItemsReqd == "Y";
      this.capa.isRepeatedDeviation = this.capa.isRepeatedDeviation == "Y";
      this.capa.lackOfRegulatoryCompliance = this.capa.lackOfRegulatoryCompliance == "Y";
      this.capa.effectivenessCheckReqd = this.capa.effectivenessCheckReqd == "Y";
      this.capa.isRiskCalculationReqd = this.capa.isRiskCalculationReqd == "Y";
      this.message.showRiskTab = this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

      this.qualityService.activity = this.capa;

      this.getDynamicButtons();
      this.getStageUsers();
      this.selectBoxForRequestedAt();
      this.ownerList.length && this.selectBoxForOwner();
      this.setDropdown();
      this.qualityService.refereshBreadCrumb = true;
    });
  }

  private selectBoxForDepartment(): void {
    this.departmentCodeDropdown = this.dropDownForDepartment?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onDepartmentSelect(event: any, item: any): void {
    if (event.isUserInput)
      this.handleDropDownValidation('department-validation', item);
  }

  private selectBoxForDesignation(): void {
    this.designationCodeDropdown = this.dropDownForDesignation?.map((designation: any) => ({
      valueExp: designation.codelistCode,
      displayExp: designation.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  private selectBoxForCapaType(): void {
    this.capaTypeDropdown = this.dropDownForCapaType?.map((type: any) => ({
      valueExp: type.type,
      displayExp: type.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onCapaTypeSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('capaType-validation', item);

      if (item) {
        this.isProcessing = true;
        this.appService.getTypeSettingsByType(this.qualityService.selectedActivityGroupId, this.qualityService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
          if (response?.toBeStartedInDays != null) {
            let date = new Date();
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setDate(date.getDate() + response.toBeStartedInDays);
            this.capa.expectedToBeStartedOn = date;
          }

          if (response?.toBeClosedInDays != null) {
            let date = new Date();
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            this.capa.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
            this.capa.expcetedClosureOn = date;
          }

          this.isProcessing = false;
        })
        this.showChangeTypeIfNa = false;
      } else {
        this.showChangeTypeIfNa = false;
      }
    }
  }

  isBusinessAreaEmpty: boolean = false;
  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = [];
    this.requestedAtDropdown = this.dropDownForRequestedAt?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == this.capa.requestedAt);
    this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;

    if (!this.isBusinessAreaEmpty) {
      this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
      this.selectBoxForCoreBusinessAreaName();
    }
  }

  businessAreaName: any;
  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;
  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('requestedAt-validation', item);
      if (item) {
        this.businessAreaName = item.displayExp;

        const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.coreBusinessAreaNameDropdown, this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
      }
    }
  }

  private selectBoxForCoreBusinessAreaName(): void {
    this.coreBusinessAreaNameDropdown = [];
    this.coreBusinessAreaNameDropdown = this.dropDownForCoreBusinessArea?.map((value: any) => ({
      valueExp: value,
      displayExp: value
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onCoreBusinessAreaNameSelect(event: any, item: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('coreBusinessArea-validation', this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue);
        this.isAllBusinessAreaSelected = this.coreBusinessAreaNameDropdown.length == this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue.length;
      });
    }
  }

  private selectBoxForOwner(): void {
    const groupOwner = this.qualityService.selectedGroupDetailData.isGroupOwnerRequired == 'Y' || this.capa.owner == 100;
    const owners = this.ownerList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
    const status = ['Draft', 'Department Head Requested More Info.', 'Department Head Approved', 'Department Head Rejected', 'QA Requested More Info.', 'QA Acceptance Rejected', 'Owner Requested More Info.', 'Pending Department Head Approval', 'QA Accepted', 'Pending QA Acceptance', 'Owner Acknowledgement Pending'];
    const isStatusPassed = status.includes(this.capa.status);
    setTimeout(() => { this.ownerDropdown = (groupOwner && isStatusPassed) ? [{ valueExp: 100, displayExp: 'Group Owners' }, ...owners] : owners; }, 500)
  }

  public onOwnerSelect(event: any, item: any): void {
    if (event.isUserInput)
      this.handleDropDownValidation('owner-validation', item);
  }

  private selectBoxForQa(): void {
    this.qaDropdown = this.qaList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onQaUserSelect(event: any, item: any): void {
    if (event.isUserInput)
      this.handleDropDownValidation('qaUser-validation', item);
  }

  private selectBoxForReasonForChange(): void {
    this.reasonForCapaDropdown = this.reasonForChangeList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onReasonForCapaSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('reasonForCapa-validation', item);
      if (item) {
        if (item.displayExp == 'Others') {
          [this.visibleReasonForChangeIfOthers, this.qualityService.activity.reasonForCapa] = [true, ''];
        } else this.visibleReasonForChangeIfOthers = false;
        setTimeout(() => {
          this.isAllReasonSelected = this.reasonForCapaDropdown.length == this.qualityService.capaPageAllDropdownValues.reasonForCapaValue.length;
        });
      }
    }
  }

  private selectBoxForRootCause(): void {
    this.rootCauseDropdown = this.rootCauseList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onRootCauseCategorySelect(event: any, item: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('rootCauseCategory-validation', this.qualityService.capaPageAllDropdownValues.selectedRootCauseCategory);
        this.allRootCauseCategorySelected = this.rootCauseDropdown.length == this.qualityService.capaPageAllDropdownValues.selectedRootCauseCategory.length;
      });
    }
  }

  private selectBoxForDepartmentHead(): void {
    this.departmentHeadDropdown = this.departmentHeadList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onDhUserSelect(event: any, item: any): void {
    if (event.isUserInput)
      this.handleDropDownValidation('dhUser-validation', item);
  }

  private handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    if (fieldId == 'capaType-validation' && !this.isTypeMandatory) return;
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  private getStageUsers(): void {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.capa.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.capa.capaNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
        this.setAesthetic();
      });
    } else {
      this.setAesthetic();
    }
  }

  private processButtonLabels(buttonLabels: string[] | null): string[] {
    const labels = buttonLabels ? [...buttonLabels] : [];
    labels.unshift("Cancel");  // Always add Cancel
    this.qualityService.activityDynamicButtonList = labels;

    // Reset flags
    this.qualityService.showflexifieldshow = false;
    this.qualityService.activitySaveButton = false;

    for (const element of labels) {
      if (/Submit|Review|Approve|Accept/.test(element)) {
        this.qualityService.showflexifieldshow = true;
      }
      if (element === "Save") {
        this.qualityService.activitySaveButton = true;
      }
    }

    return labels;
  }

  private setDropdown(): void {

    const matchingRequestedAt = this.dropDownForRequestedAt?.find((item: any) => item.taskRequestedAt === this.capa.requestedAt);
    if (!matchingRequestedAt) {
      this.isRequestedAtOdd = this.capa.requestedAt;
      this.requestedAtDropdown.push({
        valueExp: this.capa.requestedAt,
        displayExp: this.capa.requestedAt
      })
    }
    this.qualityService.capaPageAllDropdownValues.requestedAtValue = this.businessAreaName = this.capa.requestedAt;

    const selectedBusinessArea = this.isBusinessAreaEmpty ? this.capa.coreBusinessAreaName : this.capa.coreBusinessAreaName?.split(',') ?? [];
    this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue = selectedBusinessArea;
    setTimeout(() => {
      if (!this.isBusinessAreaEmpty) {
        this.isAllBusinessAreaSelected = this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue.length == this.coreBusinessAreaNameDropdown.length;
      }
    }, 1500);


    if (this.capa.deptCode) {
      let matchingDepartment = this.dropDownForDepartment.find((x: any) => x.codelistCode === this.capa.deptCode);
      if (matchingDepartment) {
        this.isDepartmentOdd = null;
      } else {
        this.isDepartmentOdd = this.capa.deptCode;
        this.departmentCodeDropdown.push({
          valueExp: this.capa.deptCode,
          displayExp: this.capa.deptCode
        });
      }
      this.qualityService.capaPageAllDropdownValues.departmentValue = this.capa.deptCode;
    }

    if (this.capa.departmentHead) {
      let matchingDepartmentHead = this.departmentHeadDropdown.find((x: any) => x.valueExp === this.capa.departmentHead);
      if (matchingDepartmentHead) {
        this.isDhOdd = null;
      } else {
        this.isDhOdd = this.capa.departmentHead;
        this.departmentHeadDropdown.push({
          valueExp: this.capa.departmentHead,
          displayExp: this.capa.departmentHeadUserName
        })
      }
      this.qualityService.capaPageAllDropdownValues.departmentHeadUserValue = this.capa.departmentHead;
    }

    if (this.capa.qaUser) {
      let matchingQa = this.qaDropdown.find((x: any) => x.valueExp === this.capa.qaUser);
      if (matchingQa) {
        this.isQAOdd = null;
      } else {
        this.isQAOdd = this.capa.qaUser;
        this.qaDropdown.push({
          valueExp: this.capa.qaUser,
          displayExp: this.capa.qaUserName
        })
      }
      this.qualityService.capaPageAllDropdownValues.qaUserValue = this.capa.qaUser;
    }

    if (this.capa.owner || this.capa.owner == 0) {
      setTimeout(() => {
        let matchingOwner = this.ownerDropdown.find((x: any) => x.valueExp === this.capa.owner);
        if (matchingOwner) {
          this.isOwnerOdd = null;
        } else {
          this.isOwnerOdd = this.capa.owner;
          this.ownerDropdown.push({
            valueExp: this.capa.owner,
            displayExp: this.capa.ownerUserName
          })
        }
      }, 2000)
      this.qualityService.capaPageAllDropdownValues.ownerValue = this.capa.owner;
    }

    if (this.capa.capaType) {
      this.qualityService.capaPageAllDropdownValues.capaTypeValue = this.capa.capaType;
      let matchingCapaType = this.capaTypeDropdown.filter((x: any) => x.valueExp === this.capa.capaType);
      if (matchingCapaType.length == 0) {
        this.isCapaTypeOdd = this.capa.capaType;
        this.capaTypeDropdown.push({
          valueExp: this.capa.capaType,
          displayExp: this.capa.capaType
        });
      } else {
        this.isCapaTypeOdd = null;
      }
    } else {
      this.qualityService.capaPageAllDropdownValues.capaTypeValue = null;
    }
    this.qualityService.capaPageAllDropdownValues.reasonForCapaValue = this.capa.reasonForCapaCode?.split(',') ?? []
    this.qualityService.activity.reasonForCapa = this.capa.reasonForCapa;
    this.visibleReasonForChangeIfOthers = this.qualityService.capaPageAllDropdownValues.reasonForCapaValue?.includes('Others');

    setTimeout(() => {
      this.isAllReasonSelected = this.reasonForCapaDropdown.length == this.qualityService.capaPageAllDropdownValues.reasonForCapaValue.length;
    })
    this.qualityService.capaPageAllDropdownValues.selectedRootCauseCategory = this.capa.rootcauseCategory?.split(',') ?? []
  }

  private getDynamicButtons(): void {
    const obj = {
      activityId: this.message.activityId,
      moduleName: this.qualityService.moduleName,
      status: this.capa.status
    }

    this.appService.getQmsButtons(obj).subscribe((data: any) => {
      this.qualityService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qualityService.activitySaveButton = false;

      if (data.resultType === "S") {
        this.qualityService.showflexifieldshow = false;
        this.stageName = data.stageName;
        this.isProcessing = false;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qualityService.activityButtonLabels = data;
        this.buttonLabels = this.processButtonLabels(data.buttonLabels?.split(",") || null);

      } else {
        this.buttonLabels = this.processButtonLabels(null);
        this.showSnackBar(data.result, data.resultType);
      }
    });
  }

  public statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  public focusSearch(value: any): void {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  };

  public getColor(status: any): string {
    if (status !== undefined && status !== null) {
      if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
        return 'red';
      } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
        return 'orange';
      } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
        return 'green';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  public readonly commonDateConfig: Readonly<Partial<BsDatepickerConfig>> = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    adaptivePosition: true,
  }

  public readonly $present_future_config: Readonly<Partial<BsDatepickerConfig>> = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  public readonly dateTimeConfig: Readonly<Partial<BsDatepickerConfig>> = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  public onExpectedToBeStartedOnChange(): void {
    if (this.qualityService.activity.expcetedClosureOn && (this.qualityService.activity.expcetedClosureOn < this.qualityService.activity.expectedToBeStartedOn)) this.qualityService.activity.expcetedClosureOn = null;
  }

  public $expected_closure_dynamic_config(): Partial<BsDatepickerConfig> {
    return {
      ...this.commonDateConfig,
      minDate: this.qualityService.activity.expectedToBeStartedOn ? new Date(this.qualityService.activity.expectedToBeStartedOn) : new Date()
    }
  }

  public handleExpectedStartChange(value: any): void {
    this.onNgModelChange(value, 'expectedToBeStartedOn-validation');

    if (
      this.qualityService.activity.expcetedClosureOn &&
      this.qualityService.activity.expcetedClosureOn < value
    ) {
      this.qualityService.activity.expcetedClosureOn = null;
    }
  }


  @ViewChild('reason') reason: MatSelect;
  @ViewChild('businessArea') businessArea: MatSelect;
  @ViewChild('rootCauseCategory') rootCauseCategory: MatSelect;

  public toggleAllSelection(value: any): void {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) {
        this.businessArea.options.forEach((item: MatOption) => item.select());
      } else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('coreBusinessArea-validation', this.qualityService.capaPageAllDropdownValues.coreBusinessAreaNameValue);
      });
    } else if (value == 'reason') {
      this.visibleReasonForChangeIfOthers = this.isAllReasonSelected;
      this.qualityService.activity.reasonForCapa = null;

      if (this.isAllReasonSelected) {
        this.reason.options.forEach((item: MatOption) => item.select());
      } else {
        this.reason.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.capaPageAllDropdownValues.reasonForCapaValue = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('reasonForCapa-validation', this.qualityService.capaPageAllDropdownValues.reasonForCapaValue);
      });
    } else if (value == 'rootCauseCategory') {
      if (this.allRootCauseCategorySelected) {
        this.rootCauseCategory.options.forEach((item: MatOption) => item.select());
      } else {
        this.rootCauseCategory.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.capaPageAllDropdownValues.selectedRootCauseCategory = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('rootCauseCategory-validation', this.qualityService.capaPageAllDropdownValues.selectedRootCauseCategory);
      });
    }
  }

  public onNgModelChange(items: any, fieldId: string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  public onStEditorChange(items: any, fieldId: string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  private fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
      !element && console.log('Unable to find the element. Id → ', element);
    });
  }

  private isContentEmpty(content: string): boolean {
    const tempDiv = document.createElement('div'); /* Create a temporary element to parse the HTML */
    tempDiv.innerHTML = content;

    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? ''; /* Get the text content and trim it */
    return textContent.trim().length === 0;
  }

  public limitCharacters(event: Event, field: string) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    const fieldMapping: { [key: number]: string[] } = {
      1000: ['REASON_FOR_CHANGE', 'REQUESTED_AT'],
      400: ['SHORT_DESCRIPTION'],
      4000: ['TYPE_UPDATE_JUSTIFICATION']
    };

    let charLimit = 4000;
    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }
    if (textLength > charLimit) {
      this.showSnackBar(`Maximum ${charLimit} characters allowed!`, 'E');
      target.value = target.value.substring(0, charLimit);

      if (field === 'SHORT_DESCRIPTION') {

        this.qualityService.activity.shortDescription = target.value;
      }
    }
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  async update(): Promise<boolean> {
    this.qualityService.validatedCapaArray = [];
    let validationPromises: any[] = [];

    const dd = this.qualityService.capaPageAllDropdownValues;
    const capa = this.qualityService.activity;

    if (!this.skipValidationsWhileSwitchingUser) {
      validationPromises.push(
        { condition: !dd.departmentValue && this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y', id: 'department-validation' },
        { condition: !dd.ownerValue, id: 'owner-validation' },
        { condition: !dd.capaTypeValue && this.isTypeMandatory, id: 'capaType-validation' },
        { condition: !dd.requestedAtValue, id: 'requestedAt-validation' },
        { condition: !dd.coreBusinessAreaNameValue.length, id: 'coreBusinessArea-validation' },
        { condition: !dd.reasonForCapaValue.length && this.dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y', id: 'reasonForCapa-validation' },
        { condition: dd.reasonForCapaValue.length && dd.reasonForCapaValue.join(',').includes('Others') && !capa.reasonForCapa, id: 'reasonForChangeIfOthers-validation' },
        { condition: !capa.expcetedClosureOn, id: 'expcetedClosureOn-validation' },
        { condition: !capa.expectedToBeStartedOn && this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y', id: 'expectedToBeStartedOn-validation' },
        { condition: !capa.shortDescription, id: 'shortDescription-validation' },
        { condition: !capa.capaDescription || this.isContentEmpty(capa.capaDescription), id: 'capaDescription-validation' },
        { condition: this.capa.qaUser != 0 && !dd.qaUserValue, id: 'qaUser-validation' },
        { condition: this.capa.departmentHead != 0 && !dd.departmentHeadUserValue, id: 'dhUser-validation' },
        { condition: this.message.showCRDetailsSection && !dd.selectedRootCauseCategory.length && this.dynamicLabel['ROOTCAUSE_CATEGORY'].isRemovable != 'Y', id: 'rootCauseCategory-validation' },
        { condition: this.message.showCRDetailsSection && (!capa.investigationSummary || this.isContentEmpty(capa.investigationSummary)), id: 'investigationSummary-validation' }
      );
    }
    const invalidIds = validationPromises.filter(v => v.condition).map(v => v.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    }
    try {
      await Promise.all(validationPromises);
      const isValidCapa = !invalidIds.length;
      const isValidFlexibleFields = !this.skipValidationsWhileSwitchingUser && this.flexibleComponent.mandatoryValidation();
      const isValid = isValidCapa && !isValidFlexibleFields;

      if (isValid) {
        const obj = await this.prepareObj(this.qualityService.activity, this.qualityService.capaPageAllDropdownValues);
        const result = await this.execute(obj); // wait for API
        return result;
      } else {
        this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
        return false;
      }
    } catch (error) {
      console.error('Error occurred during validation:', error);
      return false;
    }

  }

  private formatDate(date?: any): string | null {
    return date ? this.appService.dateZoneConvertion(new Date(date)) : null;
  }

  private mapBooleanToYN(value?: boolean): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }

  async prepareObj(capa: any, dropDown: any) {
    return {
      groupId: capa.groupId,
      capaId: capa.capaId,
      capaNo: capa.capaNo,
      initiatedBy: dropDown.initiatedBy,
      qaUser: dropDown.qaUserValue ?? 0,
      deptCode: dropDown.departmentValue ?? null,
      departmentHead: dropDown.departmentHeadUserValue ?? 0,
      owner: dropDown.ownerValue ?? null,
      requestedAt: dropDown.requestedAtValue ?? null,
      coreBusinessAreaName: this.isBusinessAreaEmpty ? dropDown.coreBusinessAreaNameValue : dropDown.coreBusinessAreaNameValue.join(','),
      reasonForCapaCode: dropDown.reasonForCapaValue.length ? dropDown.reasonForCapaValue.join(',') : null,
      reasonForCapa: capa.reasonForCapa ?? null,
      capaType: dropDown.capaTypeValue ?? null,
      expcetedClosureOn: this.formatDate(capa.expcetedClosureOn),
      expectedToBeStartedOn: this.formatDate(capa.expectedToBeStartedOn),
      startedOn: capa.startedOn,
      completedOn: this.formatDate(capa.completedOn),
      isRepeatedDeviation: this.mapBooleanToYN(capa.isRepeatedDeviation),
      lackOfRegulatoryCompliance: this.mapBooleanToYN(capa.lackOfRegulatoryCompliance),
      effectivenessCheckReqd: this.mapBooleanToYN(capa.effectivenessCheckReqd),
      isRiskCalculationReqd: this.mapBooleanToYN(capa.isRiskCalculationReqd),
      actionItemsReqd: this.mapBooleanToYN(capa.actionItemsReqd),
      preActionItemsReqd: this.mapBooleanToYN(capa.preActionItemsReqd),
      expectedClouserFromSettings: this.mapBooleanToYN(capa.expectedClouserFromSettings),
      finalNoGenerated: this.mapBooleanToYN(capa.finalNoGenerated),
      shortDescription: capa.shortDescription,
      rootCauseAnalysis: capa.rootCauseAnalysis,
      proposedCorrectiveAction: capa.proposedCorrectiveAction,
      proposedPreventiveAction: capa.proposedPreventiveAction,
      immediateCorrection: capa.immediateCorrection,
      investigationSummary: capa.investigationSummary,
      impactSummary: capa.impactSummary,
      conclusion: capa.conclusion,
      rootcauseCategory: dropDown.selectedRootCauseCategory.length ? dropDown.selectedRootCauseCategory.join(',') : null,
      capaDescription: capa.capaDescription,
      typeUpdateJustification: capa.typeUpdateJustification,
    };
  }

  execute(obj: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.isProcessing = true;

      this.appService.updateCapa(obj).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;

          if (Response.resultType === 'S') {
            this.ngOnInit();

            if (this.skipValidationsWhileSwitchingUser) {
              this.skipValidationsWhileSwitchingUser = false;
            } else if (this.flexibleComponent.flexibleFields.length) {
              this.flexibleComponent.save('activity', this.qualityService.activityId);
            }

            if (this.qualityService.isUpdatingCapaThroughDynBtn) {
              this.qualityService.isUpdatingCapaThroughDynBtn = false;
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }

            this.skipValidation && (this.skipValidation = false);
            resolve(true);

          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
            resolve(false);
          }
        },
        error: (error: Error) => {
          this.isProcessing = false;
          console.error('Execution error:', error);
          reject(new Error('Error Occurred'));
        }
      });
    });
  }

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  skipValidationsWhileSwitchingUser: boolean = false;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index;
    this.qualityService.selectedTabName = $event.tab.textLabel;
    this.setAesthetic();
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getCapaVwDetailsByCapaNo(this.qualityService.activityId).subscribe((capa: any) => {
        this.capa.expcetedClosureOn = this.qualityService.activity.expcetedClosureOn = new Date(capa.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';

  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'CAPA Description': this.dynamicLabel?.['CAPA_DESCRIPTION']?.fieldName,
      'Investigation Summary': this.dynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName,
      'Root Cause Analysis': this.dynamicLabel?.['ROOT_CAUSE_ANALYSIS']?.fieldName,
      'Impact Summary': this.dynamicLabel?.['IMPACT_SUMMARY']?.fieldName,
      'Immediate Correction': this.dynamicLabel?.['IMMEDIATE_CORRECTION']?.fieldName,
      'Proposed Corrective Action': this.dynamicLabel?.['PROPOSED_CORRECTIVE_ACTION']?.fieldName,
      'Proposed Preventive Action': this.dynamicLabel?.['PROPOSED_PREVENTIVE_ACTION']?.fieldName,
      'Conclusion': this.dynamicLabel?.['CONCLUSION']?.fieldName
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  isTypeMandatory: boolean = false;
  private markTypeAsMandatory(status: string): void {
    const statuses = new Set([
      'Draft',
      'Department Head Requested More Info.',
      'Department Head Rejected',
      'QA Requested More Info.',
      'QA Acceptance Rejected',
      'Owner Requested More Info.',
      'Pending Department Head Approval',
      'Department Head Approved',
      'QA Accepted',
      'Pending QA Acceptance',
      'Owner Acknowledgement Pending'
    ]);
    this.isTypeMandatory = !statuses.has(status)

  }
  isUsersLock: boolean = false;
  isFrozen: boolean = false;
  showUpdateType: boolean = false;
  isUpdateType: boolean = false;

  private setUpdateType(status: string): void {

    const statuses = new Set([
      'Draft',
      'Department Head Requested More Info.',
      'Department Head Rejected',
      'QA Requested More Info.',
      'QA Acceptance Rejected',
      'Owner Requested More Info.',
      'Pending Department Head Approval',
      'Department Head Approved',
      'QA Accepted',
      'Pending QA Acceptance',
      'Owner Acknowledged',
      'Owner Acknowledgement Pending'
    ]);

    this.showUpdateType = !statuses.has(status);
    setTimeout(() => { this.isUpdateType = this.showUpdateType && !this.isFrozen; }, 1500);
  }

  private setAesthetic(): void {
    const loggedUserId = this.message.getUserId();
    const { initiatedBy, owner, qaUser, departmentHead, status, preActionItemsReqd, actionItemsReqd, isRiskCalculationReqd, effectivenessCheckReqd } = this.qualityService.activity;

    const isInitiator = initiatedBy == +loggedUserId!;
    const isOwner = owner == +loggedUserId!;
    const isQa = qaUser == +loggedUserId!;
    const isEcPerformer = this.message.isEcPerformer = this.ecPerformerList.find((user: any) => user.userId === +loggedUserId!);
    const isEditableByQa = this.qualityService.selectedGroupDetailData.editableByQA == 'Y';
    const isDeptHead = departmentHead == +loggedUserId!;
    const isEditableByDeptHead = this.qualityService.selectedGroupDetailData.editableByDepartmentHead == "Y";
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
    const isEditableByReviewer = this.qualityService.selectedGroupDetailData.editableByReviewers == "Y";
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
    const isEditableByApprover = this.qualityService.selectedGroupDetailData.editableByApprovers == "Y";
    const isPreActions = preActionItemsReqd;
    const isActions = actionItemsReqd;
    const isRisk = isRiskCalculationReqd && this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

    this.qualityService.elite_AccessToClosure_Reviewer_Approver = status == "In Progress" && isOwner;
    this.message.showCRDetailsSection = effectivenessCheckReqd;
    this.isUsersLock = true;

    switch (status) {
      case 'Draft':
      case 'Department Head Requested More Info.':
      case 'Department Head Rejected':
      case 'QA Requested More Info.':
      case 'QA Acceptance Rejected':
      case 'Owner Requested More Info.':
        this.draft_aesthetic(isInitiator, isPreActions, isActions, isRisk);
        break;

      case 'Pending Department Head Approval':
        this.dept_head_approval_aesthetic(isDeptHead, isEditableByDeptHead, isPreActions, isActions, isRisk);
        break;

      case 'Department Head Approved':
      case 'QA Accepted':
        this.dept_head_approved_aesthetic(isInitiator, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Acceptance':
        this.pending_qa_acceptance_aesthetic(isQa, isEditableByQa, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Approval':
        this.pending_qa_approval_aesthetic(isQa, isEditableByQa, isPreActions, isActions, isRisk);
        break;

      case 'Owner Acknowledged':
      case 'QA Rejected':
      case 'Reviewer Requested More Info.':
      case 'Review Rejected':
      case 'Approver Requested More Info.':
      case 'Approval Rejected':
      case 'Closure Reviewer Requested More Info.':
      case 'Closure Review Rejected':
      case 'Closure Approver Requested More Info.':
      case 'Closure Approval Rejected':
      case 'Revoked':
      case 'Reopened':
        this.owner_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'QA Approved':
        this.qa_approved_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'Pending Review':
      case 'Review Inprogress':
        this.initial_review_aesthetic(isReviewer, isEditableByReviewer, isPreActions, isActions, isRisk);
        break;

      case 'Pending Approval':
      case 'Approval Inprogress':
        this.initial_approval_aesthetic(isApprover, isEditableByApprover, isPreActions, isActions, isRisk);
        break;

      case 'In Progress':
        this.inprogress_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'Pending Closure Review':
      case 'Closure Review Inprogress':
        this.closure_review_aesthetic(isReviewer, isPreActions, isActions, isRisk);
        break;

      case 'Pending Closure Approval':
      case 'Closure Approval Inprogress':
        this.closure_approval_aesthetic(isApprover, isPreActions, isActions, isRisk);
        break;

      case 'Pending Delete Approval':
      case 'Pending Reopen Approval':
      case 'Pending Obsolete Approval':
      case 'Pending Revoke Approval':
      case 'Obsoleted':
      case 'Closed':
        this.freeze_aesthetic_A(isOwner, isPreActions, isActions, isRisk, status);
        break;

      case 'Owner Acknowledgement Pending':
      case 'Deleted':
        this.freeze_aesthetic_B(isPreActions, isActions, isRisk);
        break;
    }

    if (this.capa.status === 'Closed') {
      this.appService.getQmsTasksEC(this.qualityService.activityId).subscribe((data: any) => {
        this.message.showEffectiveSection = (data.length > 0) || this.qualityService.activity.effectivenessCheckReqd;
        this.message.showEffectiveActionButtons = isEcPerformer || isOwner;
      })
    } else {
      this.message.showEffectiveSection = this.message.showEffectiveActionButtons = false;
    }
    setTimeout(() => { this.setUpdateType(status) }, 1500);
    this.markTypeAsMandatory(status);
    setTimeout(() => { this.flexibleComponent.main() });
  }

  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "owner") {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted';
      return this.qualityService.validSwitchStatus;
    } else {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted' && status != 'Closed'
      return this.qualityService.validSwitchStatus;
    };
  }

  private draft_aesthetic(isInitiator: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = this.isUsersLock = !isInitiator;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isInitiator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isInitiator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isInitiator;
  }

  private dept_head_approval_aesthetic(isDeptHead: boolean, isEditableByDeptHead: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = !(isDeptHead && isEditableByDeptHead);
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isDeptHead && isEditableByDeptHead;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isDeptHead && isEditableByDeptHead;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isDeptHead;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isDeptHead && isEditableByDeptHead;
  }

  private dept_head_approved_aesthetic(isInitiator: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = true;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private pending_qa_acceptance_aesthetic(isQa: boolean, isEditableByQa: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = !(isQa && isEditableByQa);
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isQa && isEditableByQa;
  }

  private owner_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = !isOwner;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isOwner;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isOwner;
  }

  private pending_qa_approval_aesthetic(isQa: boolean, isEditableByQa: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = !(isQa && isEditableByQa);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isQa && isEditableByQa;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isQa && isEditableByQa;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isQa && isEditableByQa;
  }

  private qa_approved_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private initial_review_aesthetic(isReviewer: boolean, isEditableByReviewer: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = !(isReviewer && isEditableByReviewer);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isReviewer && isEditableByReviewer;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isReviewer && isEditableByReviewer;
  }

  private initial_approval_aesthetic(isApprover: boolean, isEditableByApprover: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = !(isApprover && isEditableByApprover);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isApprover && isEditableByApprover;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isApprover && isEditableByApprover;
  }

  private inprogress_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false; /* Locked in Stage Users Component */
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private closure_review_aesthetic(isReviewer: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private closure_approval_aesthetic(isApprover: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private freeze_aesthetic_A(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean, status: string): void {

    let grantFileAccess: boolean = false;

    if (status == 'Pending Delete Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Delete Approver")
    } else if (status == 'Pending Revoke Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Revoke Approver")
    } else if (status == 'Pending Obsolete Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Obsolete Approver")
    } else if (status == 'Pending Reopen Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Reopen Approver")
    } else if (status == 'Closed') {
      grantFileAccess = isOwner
    }

    this.isFrozen = true;
    this.message.showCRDetailsSection = status != 'Pending Delete Approval';
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = grantFileAccess;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  private freeze_aesthetic_B(isPreActions: boolean, isActions: boolean, isRisk: boolean): void {
    this.isFrozen = true;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = false;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;

  /* Note : if userBeingSwitched param values changed then regarding names need to changed in SwitchUserComponent too */
  async openswitchuser(userBeingSwitched: any) {
    this.isProcessing = true;
    if (this.qualityService.activity.status == "In Progress" && userBeingSwitched != "Owner" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else {
      this.isProcessing = false;
    }
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Owner") {
      this.message.switchedUser = this.qualityService.capaPageAllDropdownValues.ownerValue;
      this.message.switchUserCurrentValue = this.qualityService.capaPageAllDropdownValues.ownerValue;
      this.message.switchUserdropDownList = this.ownerDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (userBeingSwitched == "QA") {
      this.message.switchedUser = this.qualityService.capaPageAllDropdownValues.qaUserValue;
      this.message.switchUserCurrentValue = this.qualityService.capaPageAllDropdownValues.qaUserValue;
      this.message.switchUserdropDownList = this.qaDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (userBeingSwitched == "Department Head") {
      this.message.switchedUser = this.qualityService.capaPageAllDropdownValues.departmentHeadUserValue;
      this.message.switchUserCurrentValue = this.qualityService.capaPageAllDropdownValues.departmentHeadUserValue;
      this.message.switchUserdropDownList = this.departmentHeadDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    }
    this.switchUserComponent.openswitchuser(userBeingSwitched, "CAPA");
  };

  onChildValueEmitted() {
    this.skipValidationsWhileSwitchingUser = true;
    this.switchUserComponent.saveMethod();
    this.update();
    this.switchUserComponent.visibleswitchUserPopup.close();
    this.switchUserComponent.visibleConfirmationPopup.close();
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('historyPopup', { static: true }) historyPopup: TemplateRef<any>;
  visibleHistoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  historyPopupConfig = {
    width: '130%',
    height: '100%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  openTopicPopup() {
    this.message.communicatingFrom = this.qualityService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  cancelTopicPopup() {
    this.visibleTopicPopup.close();
  }

  openHistoryPopup() {
    this.taskActionsHistoryComponent.ngOnInit();
    this.visibleHistoryPopup = this.dialog.open(this.historyPopup, this.historyPopupConfig);
  }

  cancelHistoryPopup() {
    this.visibleHistoryPopup.close();
  }

  addWorkflow: boolean = false;
  parallelWorkflowList: any = [];
  async openAddWorkflow() {
    this.isProcessing = true;
    if (this.qualityService.activity.status == "In Progress" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addWorkflow = true;
    this.isProcessing = false;
  };

  onworkflowChildValueEmitted() {
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qualityService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
    this.addWorkflow = false;
  }

  @ViewChild(HomepagetagComponent) tagComponent!: HomepagetagComponent;
  openTag() {
    const data = { pageName: 'Detail', labelName: "Tag", tagRef: this.capa.capaId };
    this.tagComponent.openpopup(data);
  }

  onTagChildValueEmitted() { };

  navigateToRisk() {
    this.goToTabByLabel("Risk Assessment");
  };

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  @ViewChild(ModuletypeComponent) moduletypeComponent!: ModuletypeComponent;
  openmoduleType: boolean = false;
  moduleTypeData: any;
  value: any;
  //openpopup
  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.capaTypeDropdown,
      moduleTypeValue: this.qualityService.capaPageAllDropdownValues.capaTypeValue,
      expcetedClosureOn: this.qualityService.capaPageAllDropdownValues.expcetedClosureOn,
      expectedToBeStartedOn: this.qualityService.capaPageAllDropdownValues.expectedToBeStartedOn,
      moduleName: this.dynamicLabel['CAPA_TYPE'].fieldName,
      moduleStartedOnName: this.dynamicLabel['STARTED_ON'].fieldName,
      moduleclosedOnName: this.dynamicLabel['COMPLETED_ON'].fieldName
    }
    this.openmoduleType = true;
    this.moduletypeComponent.openpopup(this.moduleTypeData);
    //
  }
  onModuleTypeEmitted($event: any) {
    this.openmoduleType = false;
    this.qualityService.capaPageAllDropdownValues.capaTypeValue = $event.moduleType;
    this.qualityService.activity.expcetedClosureOn = $event.expcetedClosureOn;
    this.qualityService.activity.expectedToBeStartedOn = $event.expectedToBeStartedOn;
    this.qualityService.activity.typeUpdateJustification = $event.typeUpdateJustification;
    this.skipValidation = true;
    this.update();
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  };

  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];
  //PDF report code start

  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = [];
    for (const element of this.dropDownDataForReportTemplate) {
      this.reportTemplateDropdown = this.reportTemplateDropdown.concat({
        valueExp: element.qmsReportTemplateVwPk.templateId,
        displayExp: element.templateName
      });
    }
  }
  templateid: number;
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reportTemplate-validation', item);
    }
  }

  openExportPopup() {

    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();

    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }

  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReportGenerateFuntion() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      let data1: any = {};

      this.capa.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.capa.userId = y

      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qualityService.activity.groupId + "",

        "gridName": "CAPA",
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "CAPA_Report",
        "currentStatus": this.qualityService.activity.status,
        "groupName": thirdL[1],
        "CAPAid": this.message.activityId,
        "version": "0",
        "CAPAId": this.qualityService.activity.capaId,
        "templateId": this.selectedReportTemplateValue ?? null,
        // "templateName": this.selectedReportTemplateValue ?? null
      }
      this.isProcessing = true;
      this.appService.genRateCAPAReport(data1).subscribe((response: any) => {
        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }
  //PDF report code end

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reportLogo-validation', item);
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {

              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }

            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;

        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }
}
